import type { QueryClient } from '@tanstack/react-query'

import { paymentsQueries } from './payments.queries'

export const openBillPaymentInvoice = async (
  queryClient: QueryClient,
  organizationId: string,
  attachmentId: string,
): Promise<void> => {
  const popup = window.open('about:blank', '_blank')
  if (popup) popup.opener = null

  try {
    const attachment = await queryClient.fetchQuery(
      paymentsQueries.invoiceAttachment(organizationId, attachmentId),
    )
    if (
      !['PENDING', 'CLEAN'].includes(attachment.scanStatus) ||
      !attachment.downloadUrl
    ) {
      throw new Error('Invoice download is unavailable')
    }
    if (popup) {
      popup.location.replace(attachment.downloadUrl)
    } else {
      window.location.assign(attachment.downloadUrl)
    }
  } catch (error) {
    popup?.close()
    throw error
  }
}
